import _ from 'lodash';
import loadingOverlay from '../common/wrappers/angular-loading-overlay';

import APP_CONFIG from './app.config';
import debugService from './common/debug.service';
import geolocationService from './common/location/geolocation.service';
import {setLogger} from './common/log.helper';
import {reactToHashChanges, reactToPathChanges} from './common/hash.service';
import {noop} from './common/common.utils';
import {parseQueryString} from './common/query.utils';

/**
 * Common run functions that need to be run in every bundle.
 */

/**
 * Set the correct debug settings.
 */
function runDebug($log, DebugService) {
  'ngInject';

  const envDebug = APP_CONFIG.debug;
  const paramDebug = (parseQueryString().debug === 'true');
  const debug = envDebug || paramDebug;

  // Set the debug level to logger and DebugService for later access
  DebugService.enabled = debug;
  setLogger($log);

  if (debug) {
    $log.debug("Debug activated with environment:", APP_CONFIG); // eslint-disable-line no-console
  }
}

runDebug.imports = [debugService];

/**
 * Check if we had an error in locating the user, sets necessary flag
 * Refer to: https://github.com/arunisrael/angularjs-geolocation
 */
function runLocationErrorCheck($rootScope, GeolocationService) {
  'ngInject';

  $rootScope.$on('error', (event, data) => {
    GeolocationService.checkIfLocationUnavailable(data);
  });
}

runLocationErrorCheck.imports = [geolocationService];

/**
 * Body level key up callback so that all keypresses are caught
 */
function runKeyUpEvent($rootScope) {
  'ngInject';

  $rootScope.onBodyKeyUp = (event) => {
    $rootScope.$broadcast('keyUpEvent', event);
  };
}
runKeyUpEvent.imports = [];

/**
 * Disable AngularJS default hash change listener.
 *
 * See HashService for the reasoning for this. We don't want AngularJS to call $location when hash changes. $browser is
 * an undocumented internal service that handles browser abstraction.
 */
function disableAngularHashListener($log, $browser) {
  'ngInject';
  $log.debug('Disabling AngularJS default hash listener');

  // Remove the hash change listener
  $browser.$$applicationDestroyed();

  // Remove the check for hash change after every digest loop
  $browser.$$checkUrlChange = noop;

  // Remove the URL change callback in case something calls it
  $browser.onUrlChange = noop;

  // Remove the URL change function in case AngularJS tries to modify the hash
  $browser.url = noop;
}
disableAngularHashListener.imports = [];


function configureOverlaySpinner(bsLoadingOverlayService) {
  'ngInject';

  bsLoadingOverlayService.setGlobalConfig({
    templateUrl: 'oralLoadingOverlaySpinJs'
  });

  bsLoadingOverlayService.setGlobalConfig({
    templateOptions: {
      radius: 21,
      lines: 11,
      length: 13,
      width: 10
    }
  });
}

function setSpinnerTemplate($templateCache) {
  'ngInject';
  // Custom spinner template for bsLoadingOverlay which has an absolute wrapper element that can be used
  // to dim the background
  return $templateCache.put(
    'oralLoadingOverlaySpinJs',
    '<div class="overlay-spinner-wrapper"><div us-spinner="{{bsLoadingOverlayTemplateOptions}}"></div></div>'
  );
}

configureOverlaySpinner.imports = [
  loadingOverlay,
];

/**
 * Execute all default runs in this file.
 * @param mod An angular module object.
 * @returns The angular module object.
 */
function defaultRuns(mod) {
  return mod
  .run(runDebug)
  .run(disableAngularHashListener)
  .run(reactToHashChanges)
  .run(reactToPathChanges)
  .run(runLocationErrorCheck)
  .run(runKeyUpEvent)
  .run(configureOverlaySpinner)
  .run(setSpinnerTemplate)
  ;
}

defaultRuns.imports = _.union(
  runDebug.imports,
  disableAngularHashListener.imports,
  reactToHashChanges.imports,
  reactToPathChanges.imports,
  runLocationErrorCheck.imports,
  runKeyUpEvent.imports,
  configureOverlaySpinner.imports,
);

export {
  runDebug,
  disableAngularHashListener,
  runLocationErrorCheck,
  runKeyUpEvent,
  configureOverlaySpinner
};

export default defaultRuns;



// WEBPACK FOOTER //
// ./src/app/common.run.js